import { AuthGuard } from '@shared/auth/auth.guard';
import { activeRoleGuard } from '@shared/auth/active-role.guard';

// Journal d'audit : réservé à l'administrateur application.
export const RouteMeta = {
    canActivate: [AuthGuard, activeRoleGuard],
    data: { roles: ['ROLE_APP_ADMIN'] }
};
